/**
 * Copyright (c) 2025-2026 Four Hour Window LLC
 * All rights reserved.
 * 
 * This source code is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

import React from 'react';
import './WelcomeScreen.css';

interface WelcomeScreenProps {
  userEmail?: string;
  userName?: string;
  onContinue?: () => void;
}

function WelcomeScreen({ userEmail, userName, onContinue }: WelcomeScreenProps) {
  return (
    <div className="welcome-container">
      <div className="welcome-card">
        <div className="welcome-icon">🎉</div>
        
        <h1 className="welcome-title mouse">
          Welcome to The Merch Sherpa Sales Portal{userName ? `, ${userName}` : ''}!
        </h1>
        
        <div className="welcome-content">
          <p className="welcome-message">
            We have notified the team that you have verified your email.
          </p>
          
          <p className="welcome-message">
            We will setup your Merch Sherpa Sales Portal ASAP, so you can start to track your sales.
          </p>
          
          <p className="welcome-message highlight">
            Keep an eye out for another email that we will send as soon as it's all set up!
          </p>
        </div>

        <button
          onClick={onContinue}
          style={{ minWidth: '280px' }}
        >
          Continue to Login
        </button>
      </div>
    </div>
  );
}

export default WelcomeScreen;